<template>
  <div>
    <toolbar
        :search.sync="search"
        :add-new-disabled="availableMedicationsToCreate.length === 0"
        @clickAdd="editItem(null)"
    />

    <v-card
        elevation="3"
        class="ma-4"
        :loading="loading"
        style="min-height: 50px;"
    >
      <medications-table
          :medications="medications"
          :search="search"
          @editMedication="editItem"
      />
    </v-card>
    <confirmation ref="confirmationPopup" />
    <edit-medication-dialog
        ref="editMedicationDialog"
        :medications="medications"
        :available-medications="availableMedicationsToCreate"
        :available-routes="availableRoutes"
        :available-dose-units="availableDoseUnits"
        @deleteItem="deleteItem"
        @saved="refreshMedications"
    />
  </div>
</template>
<script>
import medsSuggestedRoutes from '@/api/medsSuggestedRoutes';
import { mapMutations } from 'vuex';
import { SET_TITLE } from '@/store/mutations';
import Confirmation from '@/components/Confirmation';
import Toolbar from '@/components/MedicationSettings/Toolbar';
import MedicationsTable from '@/components/MedicationSettings/MedicationsTable';
import EditMedicationDialog from '@/components/MedicationSettings/EditMedicationDialog';

export default {
  name: 'MedicationSettings',
  components: {
    EditMedicationDialog,
    MedicationsTable,
    Toolbar,
    Confirmation,
  },
  data() {
    return {
      loading: false,
      medications: [],
      availableMedications: [],
      search: null,
    };
  },
  computed: {
    filteredMedicationsToCreate() {
      const excludeCodes = this.medications.map(m => m.medication);
      const medications = this.availableMedications?.medications || [];
      return medications.filter(item => !excludeCodes.includes(item.code));
    },
    availableMedicationsToCreate() {
      return this.formatOptions(this.filteredMedicationsToCreate);
    },
    availableRoutes() {
      return this.formatOptions(this.availableMedications?.routes);
    },
    availableDoseUnits() {
      return this.formatOptions(this.availableMedications?.doseUnits);
    },
  },
  methods: {
    ...mapMutations([SET_TITLE]),
    async init() {
      try {
        this.loading = true;
        const [medications, availableMedications] = await Promise.all([
          medsSuggestedRoutes.getMedications(),
          medsSuggestedRoutes.getAvailableMedications(),
        ]);

        this.medications = medications;
        this.availableMedications = availableMedications;
      } finally {
        this.loading = false;
      }
    },

    async refreshMedications() {
      this.medications = await medsSuggestedRoutes.getMedications();
    },

    editItem(item = null) {
      this.$refs.editMedicationDialog.show(item);
    },
    deleteItem(item) {
      this.$refs.confirmationPopup.showConfirm(
        this.$t('medicationSettings.deleteConfirmationHeading'),
        `Do you really want to delete medication: ${item.medicationName}?`,
        async () => {
          await this.deleteMedication(item.id);
          this.$refs.editMedicationDialog.close();
        },
      );
    },
    async deleteMedication(medicationId) {
      await medsSuggestedRoutes.deleteMedication(medicationId);
      await this.refreshMedications();
    },
    formatOptions(items) {
      if (!items) return [];
      return items
        .map(({ code, name }) => ({ code, label: `${code} — ${name}` }));
    },
  },
  created() {
    this[SET_TITLE](this.$t('medicationSettings.header'));
    this.init();
  },
};
</script>
